import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import useSEO from "../hooks/useSEO";
import {
  BLOG_POSTS,
  readingTime,
  SITE_ORIGIN,
} from "../config/blogPosts";

export default function BlogListPage() {
  useSEO({
    title: "Travel Documentation Guides | GetDeparto Blog",
    description:
      "Clear guides on flight reservations, dummy tickets, visa documentation, and proof of onward travel — from the GetDeparto team.",
    canonical: `${SITE_ORIGIN}/blog`,
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Blog",
        name: "GetDeparto — Travel Documentation Guides",
        url: `${SITE_ORIGIN}/blog`,
        description:
          "Guides on flight reservations, dummy tickets, visa documentation, and proof of onward travel.",
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_ORIGIN}/` },
          { "@type": "ListItem", position: 2, name: "Blog", item: `${SITE_ORIGIN}/blog` },
        ],
      },
    ],
  });

  return (
    <div style={{ minHeight: "100vh", background: "#fff" }}>
      <Navbar />

      <main className="gd-blog-main">
        <div className="gd-blog-shell gd-blog-list-shell">
          <header className="gd-blog-list-header">
            <span className="gd-badge-blue" data-testid="blog-list-badge">
              Guides & resources
            </span>
            <h1 className="gd-blog-list-title" data-testid="blog-list-title">
              Travel Documentation Guides
            </h1>
            <p className="gd-blog-list-sub">
              Clear guides on flight reservations, dummy tickets, visa
              documentation, and proof of onward travel.
            </p>
          </header>

          <div className="gd-blog-grid-list" data-testid="blog-card-grid">
            {BLOG_POSTS.map((post) => {
              const cardTitle = post.listTitle || post.title;
              const readMin = readingTime(post.wordCount);
              return (
                <Link
                  key={post.slug}
                  to={`/blog/${post.slug}`}
                  className="gd-blog-card"
                  data-testid={`blog-card-${post.slug}`}
                >
                  <span className="gd-blog-card-category" data-testid={`blog-card-category-${post.slug}`}>
                    {post.category}
                  </span>
                  <h2 className="gd-blog-card-title">{cardTitle}</h2>
                  <p className="gd-blog-card-excerpt">{post.excerpt}</p>
                  <div className="gd-blog-card-foot">
                    <span className="gd-blog-card-read" data-testid={`blog-card-read-${post.slug}`}>
                      {readMin} min read
                    </span>
                    <span className="gd-blog-card-cta" data-testid={`blog-card-cta-${post.slug}`}>
                      Read guide <ArrowRight size={14} />
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
